export const POPULAR_BREED_NAMES = [
    "Golden Retriever",
    "Shiba Inu",
    "Bulldog",
    "Poodle",
    "Beagle",
    "Corgi",
    "Shih Tzu",
    "Labrador Retriever",
    "German Shepherd",
    "Dachshund",
    "Husky",
    "Rottweiler",
];

export function orderBreedsForBrowse<T extends { name: string }>(
    breeds: T[],
): T[] {
    const byName = new Map(
        breeds.map((breed) => [breed.name.trim().toLowerCase(), breed]),
    );
    const popular = POPULAR_BREED_NAMES.map((name) =>
        byName.get(name.toLowerCase()),
    ).filter((breed): breed is T => breed != null);
    const popularSet = new Set(popular);
    const rest = breeds
        .filter((breed) => !popularSet.has(breed))
        .sort((a, b) => a.name.localeCompare(b.name));
    return [...popular, ...rest];
}
